(ns app.front.view.group.admin.inspections.checklist-result-sets
  (:require [app.domain.inspection.model :as inspection-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.add-widget :as ui-add]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.util :as futil]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(defn- select-result-set-names [m]
  (select-keys m inspection-model/checklist-result-set-entity-name-attributes))

(rf/reg-event-fx ::create-checklist-result-set
  (fn [_ [_ authority-group-id unsaved-result-set]]
    {:comm/command {:command    :inspection/create-checklist-result-set
                    :method     :post
                    :data       (util/mmap {:data (select-result-set-names unsaved-result-set)}
                                           authority-group-id)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :inspection.checklist.result-set/notification-created}}}))

(rf/reg-event-fx ::remove-checklist-result-set
  (fn [_ [_ id]]
    {:comm/command {:command    :inspection/remove-checklist-result-set
                    :method     :post
                    :data       (util/mmap id)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :inspection.checklist.result-set/notification-removed}}}))

(rf/reg-event-fx ::edit-checklist-result-set
  (fn [_ [_ data]]
    {:comm/command {:command    :inspection/edit-checklist-result-set
                    :method     :post
                    :data       data
                    :on-success [::entities/apply-changes]
                    :notify     {:success :inspection.checklist.result-set/notification-saved}}}))

(rf/reg-sub ::checklist-result-sets
  :<- [::gas/entities-for-group]
  (fn [group-entities _]
    (->> group-entities
         (filter (eu/is-type-fn :entity.type/inspection-checklist-result-set))
         (filter (du/in-state-fn :inspection.checklist.result-set.state/active))
         (sort-by :ordered/order))))

(defn result-set-form [{:keys [tr title on-cancel on-save save-disabled save-btn-text on-input-change strings-fn]}]
  [:div.mb-4
   [ui-add/add-widget
    {:title    title
     :loading? false
     :buttons  [{:text     (tr [:cancel])
                 :on-click on-cancel}
                {:text      save-btn-text
                 :disabled? save-disabled
                 :on-click  on-save}]}
    [:div.flex.gap-4.md:gap-8.flex-col.md:flex-row
     (futil/for-frag [name-kw inspection-model/checklist-result-set-entity-name-attributes]
       [ui-i18n/localized-string-edit
        {:id                  "inspection-checklist-result-set-pass"
         :label-text          (tr [name-kw])
         :on-change           #(on-input-change name-kw %)
         :strings             (strings-fn name-kw)
         :allowed-locales-sub ::gas/allowed-locales}])]]])

(defn- some-empty? [unsaved-result-set]
  (->> unsaved-result-set
       select-result-set-names
       vals
       (map (partial p/remove-vals #(or (nil? %) (str/blank? %))))
       (some empty?)
       boolean))

(defn init-unsaved-result-set [result-set & [id]]
  (->> inspection-model/checklist-result-set-entity-name-attributes
       (mapcat (fn [attr] [attr
                           (or (-> result-set attr i18n-model/strings-map) {})]))
       (apply hash-map)
       (merge {:id (or id (:db/id result-set))})))

(defn add-result-set [{:keys [tr authority-group-id *unsaved-result-set] :as ctx}]
  (let [unsaved-result-set @*unsaved-result-set
        add-form-toggle-fn #(reset! *unsaved-result-set
                                    (when-not unsaved-result-set
                                      (init-unsaved-result-set {} "new-result-set")))]
    (if (-> unsaved-result-set :id (= "new-result-set"))
      [result-set-form (merge ctx
                              {:title           (tr [:inspection.checklist.result-set/add-new])
                               :on-cancel       add-form-toggle-fn
                               :on-save         (fn []
                                                  (>evt [::create-checklist-result-set authority-group-id unsaved-result-set])
                                                  (add-form-toggle-fn))
                               :save-disabled   (some-empty? unsaved-result-set)
                               :save-btn-text   (tr [:create])
                               :on-input-change (fn [key value]
                                                  (swap! *unsaved-result-set #(assoc % key value)))
                               :strings-fn      #(-> unsaved-result-set %)})]
      (cc/button
        {:kind             :primary
         :size             :small
         :icon             i/plus
         :disabled         (boolean unsaved-result-set)
         :icon-description (tr [:inspection.checklist.result-set/add-new])
         :on-click         add-form-toggle-fn}
        (tr [:inspection.checklist.result-set/add-new])))))

(defn result-set-row [{:keys [tr language name-col-width result-set *unsaved-result-set] :as ctx}]
  (let [unsaved-result-set @*unsaved-result-set
        result-set-id      (:db/id result-set)]
    [:<>
     [:div.flex.w-full.border.border-solid.border-gray-500.bg-gray-200.rounded.mb-2.px-3.py-4.md:py-1.items-center {:data-cy "result-row"}
      [:div.flex.w-5-6.xl:w-2-3.flex-col.md:flex-row.gap-4.md:gap-0
       (futil/for-frag [name-kw inspection-model/checklist-result-set-entity-name-attributes]
         [:div.gap-2.flex.flex-col name-col-width
          [:span.bold.md:hidden (tr [name-kw])]
          [:span (-> result-set
                     name-kw
                     (i18n-model/get-text-from-entities-or-map language))]])]
      [:div.flex.justify-end.w-1-6.xl:w-1-3
       (cc/button
         {:kind     :ghost
          :size     :small
          :disabled (boolean unsaved-result-set)
          :on-click #(reset! *unsaved-result-set (init-unsaved-result-set result-set))}
         (tr [:edit]))
       [ui/modal-confirmation-button
        {:tr                  tr
         :modal-title         (tr [:inspection.checklist.result-set/remove])
         :trigger-button-opts {:icon             i/trash
                               :size             :small
                               :kind             :ghost
                               :icon-description (tr [:inspection.checklist.result-set/remove])
                               :class-name       "only-icon-button"
                               :disabled         (boolean unsaved-result-set)}
         :on-yes-click        #(>evt [::remove-checklist-result-set result-set-id])}
        [:div (tr [:inspection.checklist.result-set/remove-confirm])]]]]
     (when (-> unsaved-result-set :id (= result-set-id))
       [result-set-form (merge ctx {:title           (tr [:inspection.checklist.result-set/edit])
                                    :on-cancel       #(reset! *unsaved-result-set nil)
                                    :on-save         #(do
                                                        (>evt [::edit-checklist-result-set unsaved-result-set])
                                                        (reset! *unsaved-result-set nil))
                                    :save-disabled   (or (= unsaved-result-set (init-unsaved-result-set result-set))
                                                         (some-empty? unsaved-result-set))
                                    :save-btn-text   (tr [:save])
                                    :on-input-change (fn [key value]
                                                       (swap! *unsaved-result-set #(assoc % key value)))
                                    :strings-fn      #(-> unsaved-result-set %)})])]))

(defn result-set-table [{:keys [tr] :as ctx}]
  (let [result-sets    (<sub [::checklist-result-sets])
        name-col-width {:class "w-5-6 md:w-1-3"}]
    [:div.mb-8
     (when (seq result-sets)
       [:div.hidden.md:flex.w-full.font-bold.text-md.text-ui-night-sky-80.mb-2.px-3
        [:div.flex.w-5-6.xl:w-2-3
         (futil/for-frag [name-kw inspection-model/checklist-result-set-entity-name-attributes]
           [:div name-col-width (tr [name-kw])])]])
     (futil/for-all [result-set result-sets]
       ^{:key (:db/id result-set)}
       [result-set-row (merge ctx (util/mmap name-col-width result-set))])]))

(defn editor [{:keys [tr] :as ctx}]
  (r/with-let [*unsaved-result-set (r/atom nil)]
    [:div.bg-ui-white.px-2.pt-4.pb-6.mt-8.rounded
     [:h3 (tr [:inspection.checklist.result-set/configured-result-sets])]
     [result-set-table (merge ctx (util/mmap *unsaved-result-set))]
     [add-result-set (merge ctx (util/mmap *unsaved-result-set))]]))
